export const createMarkup = (htmlMarkup) => {
  return { __html: htmlMarkup }
}
